// MWDH Theme - Base JavaScript
// Import shared global JavaScript
// Shared global JavaScript is loaded via the main js/app.js file

// MWDH theme-specific JavaScript functionality
console.log('MWDH theme JavaScript loaded');

// Add any MWDH theme-specific JavaScript here
// Example: theme-specific UI components, utilities, etc.
